import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__next-slider",
  "use": "icon__next-slider-usage",
  "viewBox": "0 0 13 20",
  "content": "<symbol viewBox=\"0 0 13 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__next-slider\"><title>Path</title><path d=\"M3.132 19.582a.44.44 0 0 0 .31-.128l9.369-9.295a.443.443 0 0 0 .003-.629L3.52.16a.444.444 0 0 0-.628-.002L.214 2.812a.445.445 0 0 0-.004.63l6.327 6.377-6.379 6.326a.444.444 0 0 0-.002.628l2.655 2.677a.44.44 0 0 0 .321.132z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol